import { useEffect, useMemo } from 'react';

import { warn } from '@adsk/alloy-react-helpers';

import { useReferencePickerPlugins } from '../providers/ReferencePickerPluginsProvider';

// This hook will allow us to warning the user if the plugins provided to the ReferencePicker are not available in the plugins list provided to the ReferencePickerPluginsProvider
export const usePluginsValidator = ({ targetPlugins, source }) => {
  const { allowedPlugins, loadingPlugins } = useReferencePickerPlugins();

  const pluginsMatch = useMemo(() => {
    if (!allowedPlugins || !targetPlugins || loadingPlugins) {
      return null;
    }

    return targetPlugins.every((targetPlugin) =>
      allowedPlugins.find(
        (plugin) =>
          plugin.metadata.domain === targetPlugin.metadata.domain &&
          plugin.metadata.type === targetPlugin.metadata.type,
      ),
    );
  }, [allowedPlugins, targetPlugins, loadingPlugins]);

  useEffect(() => {
    if (pluginsMatch === false) {
      warn(
        `ReferencePicker - plugins provided to ${source} are not available in the plugins list provided to the ReferencePickerPluginsProvider, this may result in unwanted entities showing up. Please make sure that the plugins provided to ${source} are available in the plugins list provided to the ReferencePickerPluginsProvider.`,
      );
    }
    // we want to warn only on miss-match and not on every plugins/targetPlugins change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pluginsMatch]);
};
